import axios from 'axios';

const api = axios.create({
  baseURL: process.env.REACT_APP_API_BASE || 'http://localhost:4000/api',
});

api.interceptors.request.use((config) => {
  const guestId = getGuestId();
  if (!config.params) config.params = {};
  config.params.guestId = guestId;
  if (
    config.method &&
    config.method.toLowerCase() !== 'get' &&
    config.data &&
    typeof config.data === 'object' &&
    !(config.data instanceof FormData)
  ) {
    config.data.guestId = config.data.guestId || guestId;
  }
  return config;
});

export function getGuestId() {
  let id = localStorage.getItem('itsasimcha_guest_id');
  if (!id) {
    id = 'guest-' + Math.random().toString(36).slice(2) + Date.now().toString(36);
    localStorage.setItem('itsasimcha_guest_id', id);
  }
  return id;
}

export function unwrap(resp) {
  return resp?.data?.body;
}

export default api;
